module.exports = __webpack_public_path__ + "img/apoca.63df323b.jpeg";